import { Campaign } from 'modules/domains/campaign';
import { DataWithGraphQLTypeName, GRAPHQL_TYPENAMES } from 'modules/graphql/types';

export type GraphQLCampaign = DataWithGraphQLTypeName<GRAPHQL_TYPENAMES.CAMPAIGN, Campaign>;

/**
 * Supported `RecurrenceSchedule` types
 */
export enum RecurrenceScheduleType {
  Daily = 'Daily',
  Weekly = 'Weekly',
  BiWeekly = 'BiWeekly',
  ThirtyDays = 'ThirtyDays',
  FirstOfTheMonth = 'FirstOfTheMonth',
  FifteenTheOfTheMonth = 'FifteenTheOfTheMonth',
  LastOfTheMonth = 'LastOfTheMonth',
  DoNotRepeat = 'DoNotRepeat',
  Custom = 'Custom',
}

/**
 * `DataFeed` types
 */

export type DataFeed = {
  id: number;
  name: string;
  projectId: number;
};

export type DataFeedMapper = Record<number, DataFeed>;
